module.exports = __webpack_public_path__ + "img/dione.8085f82c.png";